"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
require("../css/app.scss");
require("../css/landing-page.scss");
require("../css/price-table.scss");
var ScrollMagic_1 = require("ScrollMagic");
var smoothscroll = __importStar(require("smoothscroll-polyfill"));
require("classlist-polyfill");
//import { TimelineLite } from 'gsap'
var octonicaLogo_1 = __importDefault(require("./octonicaLogo"));
require("remodal");
var getScrollTop_1 = __importDefault(require("./getScrollTop"));
var ko = __importStar(require("knockout"));
var jquery_1 = __importDefault(require("jquery"));
var calculateCost_1 = require("./calculateCost");
var PriceTabs_1 = require("./PriceTabs");
octonicaLogo_1.default('.site-header');
var priceTabsApi = null;
smoothscroll.polyfill();
var controller = new ScrollMagic_1.Controller();
var elementSections = [{
        link: '#solutionsSectionLink',
        section: '#solutionsSection'
    }, {
        link: '#forWhoSectionLink',
        section: '#forWhoSection'
    }, {
        link: '#costSectionLink',
        section: '#costSection'
    }, {
        link: '#whyOctonicaSectionLink',
        section: '#whyOctonicaSection'
    }, {
        link: '#usefulInformationSectionLink',
        section: '#usefulInformationSection'
    }];
elementSections.forEach(function (p, i, items) {
    var section = document.querySelector(p.section);
    var duration = section.getBoundingClientRect().height;
    var className = 'active';
    var scene = new ScrollMagic_1.Scene({ triggerElement: section, triggerHook: 0.5, duration: i === 0 ? duration + 100 : duration, offset: i === 0 ? -100 : 0 })
        .on('enter', function () { return items.forEach(function (item) { return document.querySelector(item.link).classList.remove(className); }); })
        .setClassToggle(p.link, className)
        .addTo(controller);
    window.addEventListener('resize', function () { return scene.duration(section.getBoundingClientRect().height + (i === 0 ? 100 : 0)); });
    var link = document.querySelector(p.link);
    link.addEventListener('click', function (e) {
        var hamburger = document.querySelector('.hamburger');
        hamburger.classList.remove('opened');
        var targetElement = document.querySelector(e.target.name);
        var bb = targetElement.getBoundingClientRect();
        window.scrollBy({
            top: bb.top - 60,
            left: 0,
            behavior: 'smooth'
        });
        return false;
    });
});
window.addEventListener('scroll', function (e) {
    var currentScroll = getScrollTop_1.default();
    if (currentScroll > 80) {
        document.querySelector('.site-header').classList.add('site-header-fixed');
    }
    else {
        document.querySelector('.site-header').classList.remove('site-header-fixed');
    }
});
var hamburger = document.querySelector('.hamburger');
hamburger.addEventListener('click', function (e) { return e.target.classList.toggle('opened'); });
var scrollTop = 0;
jquery_1.default(document).on('opening', '.remodal', function () {
    jquery_1.default('body').addClass('fix-remodal');
    var offset = jquery_1.default('body').css('padding-right');
    offset = parseFloat(offset) / 2;
    jquery_1.default('.site-header').css('left', -offset + 'px');
    scrollTop = getScrollTop_1.default();
});
jquery_1.default(document).on('closed', '.remodal', function (e) {
    jquery_1.default('body').removeClass('fix-remodal');
    jquery_1.default('.site-header').css('left', '0');
    window.scrollTo({
        top: scrollTop,
        left: 0
    });
});
var viewModel = new (function () {
    var _this = this;
    this.accountNumber = ko.observable(100);
    this.calculatedCost = ko.computed(function () {
        try {
            var personalAccountCount = _this.accountNumber();
            if ((personalAccountCount + '') !== (parseInt(personalAccountCount, 10) + ''))
                return null;
            var parsedAccountCount = parseInt(personalAccountCount);
            if (parsedAccountCount < 0)
                return null;
            var cost = calculateCost_1.calculateCost(parsedAccountCount);
            return cost;
        }
        catch (ex) {
            return null;
        }
    });
});
ko.applyBindings(viewModel);
Array.from(document.getElementsByClassName('price-target-default'))
    .forEach(function (b) { return b.addEventListener('click', function () { return priceTabsApi.activate('default'); }); });
Array.from(document.getElementsByClassName('price-target-excel'))
    .forEach(function (b) { return b.addEventListener('click', function () { return priceTabsApi.activate('excel'); }); });
react_dom_1.render(react_1.default.createElement(PriceTabs_1.PriceTabs, { onInitialized: function (api) { return priceTabsApi = api; } }), document.getElementById('price-tabs'));
